import { render } from "./COverlay.vue?vue&type=template&id=687c73ae&scoped=true"
import script from "./COverlay.vue?vue&type=script&lang=js"
export * from "./COverlay.vue?vue&type=script&lang=js"

import "./COverlay.vue?vue&type=style&index=0&id=687c73ae&lang=scss&scoped=true"

import exportComponent from "/builds/advocacy/e-advokat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687c73ae"]])

export default __exports__